import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import Select from 'react-select';

const PartnerModal = ({
    showModal,
    handleClose,
    partnerId,
    partnerData,
    addPartner,
    editPartner,
    partners,
    organisations,
    fetchOrganisation,
    fetchContacts,

}) => {
    const [formData, setFormData] = useState({
        organisation_id: '',
        stage: '',
        name: '',
        value: '',
        expected_revenue: '',
        closed_date: '',
        probability: '',
        lead_source: '',
        next_steps: '',
        customer_type: '',
        remarks: '',



    });
    const [allProducts, setAllProducts] = useState([]);

    const [errors, setErrors] = useState({});
 

    useEffect(() => {
        if (showModal && organisations?.length === 0) {
            fetchOrganisation();
        }

        if (showModal && !partnerData) {
            // Reset formData for new orgs creation
            setFormData({
                organisation_id: '',
                stage: '',
                name: '',
                value: '',
                closed_date: '',
                probability: '',
                expected_revenue: '',
                lead_source: '',
                next_steps: '',
                customer_type: '',
                remarks: '',

            });
        } else if (partnerData) {
            setFormData({
                organisation_id: partnerData.organisation_id || '',
                stage: partnerData.stage || '',
                value: partnerData.value || '',
                closed_date: partnerData.closed_date || '',

                probability: partnerData.probability !== undefined ? partnerData.probability : getProbability(partnerData.stage),
                name: partnerData.name || '',
                expected_revenue: partnerData.expected_revenue || '',
                lead_source: partnerData.lead_source || '',
                next_steps: partnerData.next_steps || '',
                customer_type: partnerData.customer_type || '',
                remarks: partnerData.remarks || '',
              
            
            });

        }
    }, [partnerData, showModal]);



    const getProbability = (stage) => {
        const probabilities = {
            suspect: 10,
            prospect: 25,
            approach: 50,
            negotiation: 75,
            "closed won": 90,
            "closed lost": 0,
            "closed dead": 0,
            order: 100
        };
        return probabilities[stage] || '';
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newFormData = { ...formData, [name]: value };

        if (name === "stage") {
            // Update probability when stage changes
            const newProbability = getProbability(value);
            newFormData.probability = newProbability;
        }

        if (name === "value" || name === "stage") {
            // Recalculate expected revenue when value or stage changes
            const numericValue = parseFloat(newFormData.value) || 0;
            const numericProbability = parseFloat(newFormData.probability) || 0;
            newFormData.expected_revenue = (numericValue * numericProbability) / 100;
        }

        setFormData(newFormData);

        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
        }
    };




    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';


        return newErrors;
    };
    const [loading, setLoading] = useState(false);


    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop here if validation fails
        }
        
        let errors;
        if (partnerData) {
            errors = await editPartner(partnerData.id, formData);
        } else {
            errors = await addPartner(formData);
        }

        if (errors && Object.keys(errors).length > 0) {
            setErrors(errors); // Display validation errors
        } else {
            setErrors({}); // Clear errors on success
            handleClose(); // Close modal on success
        }
    };

    return (
        <Modal show={showModal} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    {partnerId
                        ? `Edit Partner`
                        : `Add Partner`}
                </Modal.Title>



            </Modal.Header>
            <Modal.Body>
                <form >
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="name" className="form-label" style={{ fontSize: '13px' }}>Name</label>
                                <input
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="name"
                                    id="name"
                                    type="text"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className={`form-control ${errors?.name ? 'is-invalid' : ''}`}

                                />

                                {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}

                            </div>
                        </div>
                        <div className="col-md-6">

                            <div className="form-group">
                                <label htmlFor="organisation_id" className="form-label" style={{ fontSize: '13px' }}>Organisation Name:</label>
                                <select
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="organisation_id"
                                    id="organisation_id"
                                    value={formData.organisation_id}
                                    onChange={handleChange}
                                    className='form-control '

                                >
                                    <option value="">Select </option>

                                    {organisations?.filter(org => org.id).map((org) => (
                                        <option key={org.id} value={org.id}>
                                            {org.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">

                            <div className="form-group">
                                <label htmlFor="customer_type" className="form-label" style={{ fontSize: '13px' }}>Customer Type:</label>
                                <select
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="customer_type"
                                    id="customer_type"
                                    className="form-control"
                                    value={formData.customer_type}
                                    onChange={handleChange}
                                >
                                    <option value="">Select </option>
                                    <option value="existing customer">Existing Customer </option>
                                    <option value="new customer">New Customer </option>

                                </select>

                            </div>
                        </div>
                        <div className="col-md-6">

                            <div className="form-group">
                                <label htmlFor="lead_source" className="form-label" style={{ fontSize: '13px' }}>Lead Source:</label>
                                <select
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="lead_source"
                                    id="lead_source"
                                    className="form-control"
                                    value={formData.lead_source}
                                    onChange={handleChange}
                                >
                                    <option value="">Select </option>
                                    <option value="partner">Partner </option>
                                    <option value="consultant">Consultant </option>
                                    <option value="inside sale">Inside Sales </option>
                                    <option value="sales generated">Sales Generated </option>


                                </select>

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">


                            <div className="form-group">
                                <label htmlFor="closed_date" className="form-label" style={{ fontSize: '13px' }}>Closed Date:</label>
                                <input
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="closed_date"
                                    id="closed_date"
                                    type='date'
                                    className="form-control"
                                    value={formData.closed_date}
                                    onChange={handleChange}

                                />
                            </div>

                        </div>
                        <div className="col-md-6">

                            <div className="form-group">
                                <label htmlFor="stage" className="form-label" style={{ fontSize: '13px' }}>Stage:</label>
                                <select
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="stage"
                                    id="stage"
                                    className="form-control"
                                    value={formData.stage}
                                    onChange={handleChange}
                                >
                                    <option value="">Select </option>
                                    <option value="suspect">Suspect </option>
                                    <option value="prospect">Prospect </option>
                                    <option value="approach">Approach </option>
                                    <option value="negotiation">Negotiation </option>
                                    <option value="closed won">Closed Won </option>
                                    <option value="closed lost">Closed Lost </option>
                                    <option value="closed dead">Closed Dead </option>
                                    <option value="order">Order </option>
                                </select>

                            </div>
                        </div>
                    </div>
                    <div className="row">


                        <div className="col-md-6">

                            <div className="form-group">
                                <label htmlFor="probability" className="form-label" style={{ fontSize: '13px' }}>Probability(%):</label>
                                <input
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="probability"
                                    id="probability"
                                    className="form-control"
                                    value={formData.probability !== '' ? formData.probability : '0'}
                                    onChange={handleChange}
                                    readOnly

                                />
                            </div>
                        </div>
                        <div className="col-md-6">

                            <div className="form-group">
                                <label htmlFor="value" className="form-label" style={{ fontSize: '13px' }}>Value</label>
                                <input
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="value"
                                    id="value"
                                    className='form-control'
                                    value={formData.value}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">


                            <div className="form-group">
                                <label htmlFor="expected_revenue" className="form-label" style={{ fontSize: '13px' }}>Expected Revenue:</label>
                                <input
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="expected_revenue"
                                    id="expected_revenue"
                                    className="form-control"
                                    value={formData.expected_revenue}
                                    onChange={handleChange}
                                    readOnly

                                />
                            </div>
                        </div>
                        <div className="col-md-6">


                            <div className="form-group">
                                <label htmlFor="next_steps" className="form-label" style={{ fontSize: '13px' }}>Next Step:</label>
                                <input
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="next_steps"
                                    id="next_steps"
                                    type='text'
                                    className="form-control"
                                    value={formData.next_steps}
                                    onChange={handleChange}

                                />
                            </div>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                        <div className="form-group">
                                <label htmlFor="remarks" className="form-label" style={{ fontSize: '13px' }}>Remarks:</label>
                                <textarea
                                    style={{ fontSize: '14px', maxWidth: '320px', borderRadius: '14px', height: '39px', border: '0.5px solid rgb(232, 233, 237)' }}
                                    name="remarks"
                                    id="remarks"
                                    className="form-control"
                                    value={formData.remarks}
                                    onChange={handleChange}


                                />
                            </div>
                        </div></div>

                </form>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                    Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                    Save
                </button>
            </Modal.Footer>
        </Modal >
    );
};

export default PartnerModal;
